import { http_client } from '@/plugins/http_client';
const FIRMA_DOCUMENTOS_URL = `${process.env.VUE_APP_API_EXTERNA_FIRMA_DOCUMENTOS_URL}`;

export const fetchSancionesTitular = async (params) => {
    return await http_client(`/api/sanciones/listar-sanciones?sort=estadoSolicitud`, params, 'POST');
};

export const fetchEstadoSancion = async () => {
    return await http_client("/api/catalogos/sanciones-estados", {}, 'GET');
};

export const fetchListarDelegados = async (id) => {
    return await http_client(`/api/sanciones/lista-delegados/${id}`, {}, 'GET');
}

export const pathDelegarSancion = async (id, data) => {
    return await http_client(`/api/sanciones/${id}/delegar`, data, 'PATCH');
}

export const postAcuerdoFirmado = async (id_sancion, data) => {
    return await http_client(`/api/sanciones/firmar-acuerdo/${id_sancion}`, data, 'POST');
    //return await http_client(`${FIRMA_DOCUMENTOS_URL}/api/documentos`, data, 'POST');
}

export const getAcuerdoFirmado = async (uuid) => {
    try {
        const { data, status } = await http_client(`${FIRMA_DOCUMENTOS_URL}/api/documentos/${uuid}`, {}, 'GET');
        if (status === 200) {
            return { data, status };
        }
    } catch (e) {
        return {
            error: true
        }
    }
}

export const fetchSancionEmpleado = async (id) => {
    return await http_client(`/api/sanciones/get-sancion-empleado/${id}`, {}, 'GET');
}


export const fetchAcuerdoFirmado = async (id) => {
    return await http_client(`/api/sanciones/get-documento-acuerdo/${id}`, {}, 'GET');
}
export const tomarConocimiento = async (id) => {
    return await http_client(`/api/sanciones/${id}/conocimiento`, {}, 'POST');
}

export const postDocumentosSolicitudTitular = (id, data) => {
    return http_client(`/api/sanciones/${id}/adjuntos`, data, 'POST', { 'Content-Type': 'multipart/form-data' });
}

export const postDocumentosSolicitudTitularUUID = (id, data) => {
    return http_client(`/api/sanciones/${id}/adjuntos`, data, 'POST');
}

export default {
    fetchSancionesTitular,
    fetchListarDelegados,
    pathDelegarSancion,
    postAcuerdoFirmado,
    fetchSancionEmpleado,
    fetchAcuerdoFirmado,
    postDocumentosSolicitudTitular,
    tomarConocimiento,
    fetchEstadoSancion,
    postDocumentosSolicitudTitularUUID,
    getAcuerdoFirmado
};
